export default "__VITE_ASSET__DGc9ZZqC__"